import { iots } from '@code-expert/prelude';
import { end, formatRoute, lit, query, url } from '/imports/modules/Routing';

export const indexRoute = url(end);
export const infoRoute = url(lit('info'), end);

export const loginRoute = url(lit('login'), end);

export const loginDemoRoute = url(
  lit('loginDemo'),
  query(iots.exact(iots.partial({ redirect: iots.string }))),
  end,
);

const logoutRoute = url(lit('logout'), end);

export const logoutLink = formatRoute(logoutRoute);
